import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BadgesContextualVariations } from "../../../../Constant";
import { BADGES_CONTEXT, BADGES_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";

const BadgesContextualVariationsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={BadgesContextualVariations} span={BADGES_DATA} />
        <CommomTagAndPillsCardBody data={BADGES_CONTEXT} />
      </Card>
    </Col>
  );
};

export default BadgesContextualVariationsCart;
